export class ImageNumber extends createjs.BitmapText {
    textWidth: number;
    textHeight: number;
    baseX: number;
    baseY: number;
    default: number;
    align: string;
    max: number
    constructor(path: string, textWidth: number, textHeight: number, data: { baseX?: number, baseY?: number, default?: number, align?: string, max?: number }) {
        super();
        this.textWidth = textWidth;
        this.textHeight = textHeight;
        this.baseX = data.baseX ? data.baseX : 0;
        this.baseY = data.baseY ? data.baseY : 0;
        this.default = data.default ? data.default : 0;
        this.align = data.align ? data.align : "left";
        this.max = data.max ? data.max : 99999999;

        var param = {
            images: [path],
            frames: { width: textWidth, height: textHeight, count: 10 },
            animations: { "0": 0, "1": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9 }
        }
        this.spriteSheet = new createjs.SpriteSheet(param);
        this.y = this.baseY;
        this.setNumber(this.default);

    }
    setNumber(number:number) {
        if (number && this.max) {
            if (number > this.max) {
                number = this.max;
            }
        }
        this.text = number.toString();
        switch (this.align) {
            case "left":
                this.x = this.baseX;
                break;
            case "center":
                var textLength = this.text.length;
                this.x = this.baseX - (textLength * this.textWidth) / 2;
                break;
            case "right":
                var textLength = this.text.length;
                this.x = this.baseX - textLength * this.textWidth;
                break;
            default:
                break;
        }
    }
}